import { useCallback, useEffect, useState } from "react";
import PropTypes from "prop-types";

import { tranStr } from "../../utils/translation";

import "./BenchmarkingDisplayTable.css";
import Table from "../table/Table";
import isEmpty from "../../validation/is-empty";

/// props validation | SQ(javascript:S6774)
ProjectSpecifications.propTypes = {
  thisBenchmark: PropTypes.object,
  benchmarks: PropTypes.array,
  caller: PropTypes.string,
  moduleId: PropTypes.string,
  specificationInfo: PropTypes.string,
  specificatonsList: PropTypes.array,
  dashboardID: PropTypes.string,
};
export default function ProjectSpecifications(props) {
  const {
    thisBenchmark,
    benchmarks,
    caller,
    specificationInfo,
    specificatonsList,
    moduleId,
    dashboardID,
  } = props;

  const [selectedRow, setSelectedRow] = useState({});
  const [displayedColumns, setDisplayedColumns] = useState([]);

  const bmSummary = [thisBenchmark].concat(benchmarks);
  const heading = bmSummary.map((bm) => getBenchmarkName(bm));

  // Create columns for the table
  // The columns will have a heading, a key, a type and a width
  // The heading will be the label of the specification
  // The key will be the key of the specification
  // The type will be TEXT
  // The width will be 250
  // If selectedColumns is not empty, filter the columns to only include the selected ones
  const columns = useCallback(
    (selectedColumns) => {
      let colObj = {
        heading: tranStr(specificationInfo),
        key: "project_specification",
        type: "TOOLTIP",
        width: 250,
      };
      const columns = [];
      columns.push(colObj);
      for (let i = 0; i < bmSummary.length; i++) {
        const col = {
          heading: heading[i],
          key: "benchmark" + i,
          type: "NUMBER",
          width: 250,
        };
        columns.push(col);
      }
      // If no selected columns are passed, return all columns
      if (isEmpty(selectedColumns)) {
        setDisplayedColumns(columns);
        return columns;
      }
      let columnsToBeReturned = columns.filter(function (el) {
        return selectedColumns.indexOf(el.key) >= 0;
      });
      return columnsToBeReturned;
    },
    [bmSummary.length, heading, specificationInfo]
  );

  useEffect(() => {
    columns([]);
  }, [columns]);

  // Create an array of objects, each object will have a key for each specification
  // and a value for each benchmark
  // The key will be the specification key and the value will be the value from the benchmark object
  // The object will have a key for the project specification and a key for each benchmark
  // The value for the project specification will be the label of the specification
  let data = [];
  specificatonsList.forEach((specification) => {
    let isDataAvaialble = false;
    let obj = {
      project_specification: specification.label,
      tooltip: specification.tooltip,
    };
    bmSummary.forEach((benchmark, i) => {
      obj["benchmark" + i] = benchmark[specification.key] || "";
      if (dashboardID === "BENCHMARK_PROJECT_SCHEDULE_SPECIFICATION") {
        if (
          !isEmpty(benchmark["planned_construction_duration"]) &&
          benchmark["planned_construction_duration"] !== "0" &&
          benchmark["planned_construction_duration"] !== "∞"
        ) {
          isDataAvaialble = true;
        }
      } else {
        if (!isEmpty(benchmark[specification.key])) {
          isDataAvaialble = true;
        }
      }
    });

    if (isDataAvaialble) {
      data.push(obj);
    }
  });

  // Render the table with the data and columns
  if (data.length === 0) {
    return null;
  }
  return (
    <div className="specification bm_display_table">
      <Table
        title={tranStr(specificationInfo)}
        tableArray={data}
        columns={displayedColumns}
        tableSize={data.length}
        isTitleDisabled={true}
        isTotalDisabled={true}
        isPaginationDisabled={true}
        isFilterDisabled={true}
        // Row Selection
        selectedRow={selectedRow}
        setSelectedRow={setSelectedRow}
        // Modal Control
        setModal={() => {}}
        discriminator={caller}
        moduleId={moduleId}
        isMenuAvailable={false} // No menu available for this table
        maxFilterCols={10}
      />
    </div>
  );
}

function getBenchmarkName(benchmark) {
  let name = "";
  if (isEmpty(benchmark.project_name_short)) {
    if (!isEmpty(benchmark.project_name)) {
      if (benchmark.project_name.length > 12) {
        name = benchmark.project_name.slice(0, 9) + "...";
      } else {
        name = benchmark.project_name;
      }
    }
  } else {
    name = benchmark.project_name_short;
  }
  return name;
}
